export enum GameSpotTheDifferencePositionType {
  NEXT_TO = 'nextto',
  ABOVE = 'above'
}
